
import Vue from "vue";
import { email, required, minLength } from "vuelidate/lib/validators";
import { MemberRole } from "../models/Member";

export default Vue.extend({
  name: "ManageMemberInviteModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    companies: {
      type: Array as () => Array<{ id: number; title: string }>,
      default: () => [],
    },
  },
  data() {
    return {
      email: "",
      role: "",
      selectedCompanyIds: [] as number[],
      existingUser: null as { id: number; name: string; role: string } | null,
      isCheckingEmail: false,
      isNewUser: false,
      emailCheckError: null as string | null,
    };
  },
  validations: {
    email: { required, email },
    role: { required },
    selectedCompanyIds: { required: (val: number[]) => val.length > 0 },
    validationGroup: ["email", "role", "selectedCompanyIds"],
  },
  computed: {
    roles() {
      return [MemberRole.OWNER, MemberRole.OWNER_RVS, MemberRole.MEMBER, MemberRole.SUPERMEMBER];
    },
    localDialog: {
      get(): boolean {
        return this.value;
      },
      set(val: boolean) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    async onEmailBlur() {
      if (!this.$v.email.required || !this.$v.email.email) return;
      this.emailCheckError = null;
      this.existingUser = null;
      this.isNewUser = false;
      this.isCheckingEmail = true;
      try {
        const result = await (this as any).$dep.manageMemberService.checkMemberEmail(this.email);
        if (result.exists) {
          if (result.role === "admin") {
            this.emailCheckError = "Admin users cannot be invited.";
          } else {
            this.existingUser = result;
            this.role = result.role;
          }
        } else {
          this.isNewUser = true;
        }
      } catch {
        // silent — allow invite to proceed if check fails
      } finally {
        this.isCheckingEmail = false;
      }
    },
    invite() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$v.$reset();
      this.$emit("invite", {
        email: this.email,
        role: this.role,
        company_ids: this.selectedCompanyIds,
      });

      this.localDialog = false;
    },
  },
  watch: {
    value(open: boolean) {
      if (open) {
        this.email = "";
        this.role = "";
        this.selectedCompanyIds = [];
        this.existingUser = null;
        this.isCheckingEmail = false;
        this.isNewUser = false;
        this.emailCheckError = null;
        this.$v.$reset();
      }
    },
    email() {
      this.existingUser = null;
      this.isNewUser = false;
      this.emailCheckError = null;
    },
  },
});
